import { render, staticRenderFns } from "./AccountantSettlement.vue?vue&type=template&id=c5c0f00a&scoped=true"
import script from "./AccountantSettlement.vue?vue&type=script&lang=js"
export * from "./AccountantSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c0f00a",
  null
  
)

export default component.exports